import { httpRequest } from '@/clients/http'
import { local } from '@/db/repositories/local'
import * as orders from '@/db/repositories/orders'
import { configService } from '@/services/ConfigService'
import { Paginated, PosHttpParams, PosModel } from '@/types'

/** With a backend, sales are written to the device and synced (POS.md §15.1); the demo keeps its in-memory API. */
export const OrderModel = {
  getList: (query?: { search?: string; shift?: boolean }) =>
    configService.isDemo()
      ? httpRequest<Paginated<PosModel.Order>>({ method: 'get', url: '/pos/orders', query: { ...query } })
      : local(orders.getOrders(query)),

  create: (body: PosHttpParams.CreateOrder) =>
    configService.isDemo()
      ? httpRequest<PosModel.Order>({ method: 'post', url: '/pos/orders', body })
      : local(orders.createOrder(body)),

  refund: (id: string) =>
    configService.isDemo()
      ? httpRequest<PosModel.Order>({ method: 'post', url: `/pos/orders/${id}/refund` })
      : local(orders.refundOrder(id)),

  /** Device only: cancelled on the device and synced (POS.md §15.2). */
  cancel: (id: string, reason?: string) => local(orders.cancelOrder(id, reason)),

  /** Device only: the demo API refunds whole orders. */
  returnItems: (id: string, request: orders.ReturnRequest) => local(orders.returnItems(id, request)),
}
